import AnalyticsInitializer from './AnalyticsInitializer';

export default AnalyticsInitializer;
